import { render, staticRenderFns } from "./AppPicture.vue?vue&type=template&id=3835977d&scoped=true&"
import script from "./AppPicture.vue?vue&type=script&lang=js&"
export * from "./AppPicture.vue?vue&type=script&lang=js&"
import style0 from "./AppPicture.vue?vue&type=style&index=0&id=3835977d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835977d",
  null
  
)

export default component.exports